import React from "react";
import { useNavigate } from "react-router";
import peerReview from "../../../assets/peer-review.svg";
import upwardReview from "../../../assets/upward-review.svg";
import crossReview from "../../../assets/cross-review.svg";
import Layout from "../../../Components/Layout/Layout.module.css";
const CardComp = ({ title, subtitle, link, icon }) => {
  const navigate = useNavigate();
  return (
    <div className="px-4 py-8 border-[#DBD7D7] border-[2px] w-[300px] rounded-md flex">
      <div className="flex flex-col justify-between gap-5">
        <div className="">
          <img
            src={icon}
            alt={`${title} icon`}
            className="text-xl text-[#305F32]"
          />
        </div>
        <div className="flex flex-col gap-2 flex-1">
          <div className="text-[16px] font-bold text-[#305F32]">{title}</div>
          <div className="text-[12px] text-black">{subtitle}</div>
        </div>
        <div className=" border-[#305F32] cursor-pointer border-[2px] mt-auto rounded-md w-fit bg-white hover:opacity-50 ">
          <button
            onClick={() => navigate(link)}
            className="px-7 py-1 text-[12px] bg-white flex justify-start"
          >
            View
          </button>
        </div>
      </div>
    </div>
  );
};
const PerformanceAppraisal = () => {
  const CardData = [
    {
      title: "Peer Review",
      subtitle: "Create Appraisal period for each appraisee under supervision",
      link: "peer-review",
      icon: peerReview,
    },
    {
      title: "Upward Review",
      subtitle:
        "Create performance objectives for each appraisee under supervision",
      link: `upward-review`,
      icon: upwardReview,
    },
    {
      title: "Cross Review",
      subtitle:
        "Create performance objectives for each appraisee under supervision",
      link: `cross-review`,
      icon: crossReview,
    },
  ];
  return (
    <div className={Layout.Route_Layout}>
      <section className="grid grid-cols-3 gap-y-5">
        {CardData.map((data, index) => {
          return (
            <CardComp
              key={index}
              title={data.title}
              subtitle={data.subtitle}
              link={data.link}
              icon={data.icon}
            />
          );
        })}
      </section>
    </div>
  );
};

export default PerformanceAppraisal;
